import React, { useContext, useState } from 'react'
import { useMsal, useIsAuthenticated, useAccount } from '@azure/msal-react'
import { api } from '../utils/api'

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

const AuthContext = React.createContext()
export const useAuth = () => useContext(AuthContext)

export const AuthProvidor = ({ children }) => {
  const { instance, accounts } = useMsal()
  const isAuth = useIsAuthenticated()
  const account = useAccount(accounts[0] || {})
  const [user, setUser] = useState(null)

  const login = async () => {
    try {
      await instance.loginRedirect({
        scopes: ['User.Read'],
      })
    } catch (error) {
      console.error(error)
    }
  }

  const logout = async () => {
    try {
      setUser(null)
      await instance.logoutRedirect()
    } catch (error) {
      console.error(error)
    }
  }

  const checkAccessToken = async () => {
    const request = {
      // scopes: ['User.Read'], //Scope when reading from mGraph
      scopes: [process.env.REACT_APP_SCOPES], //Scoped to logs-intake-api
      account,
    }
    try {
      const res = await instance.acquireTokenSilent(request)
      api.defaults.headers.common['Authorization'] = `Bearer ${res.accessToken}`
      if (!user && isAuth) {
        setUser({
          name: accounts[0].name,
          email: accounts[0].username.toLowerCase(),
        })
      }
    } catch (error) {
      const res = await instance.acquireTokenPopup(request)
      api.defaults.headers.common['Authorization'] = `Bearer ${res.accessToken}`
      if (!user && isAuth) {
        setUser({
          name: accounts[0].name,
          email: accounts[0].username.toLowerCase(),
        })
      }
    }
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        accounts,
        isAuth,
        login,
        logout,
        checkAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
